import race from './parts/top/race'

(() => {
  race();
})();
